import { toast } from 'gcs-common/design-system/hooks/use-toast';
import { defaultAllowedFileTypes } from 'gcs-common/slices/tickets/ticketsConstants';
import { useDropzone } from 'react-dropzone';
import { type Path, type PathValue, type UseFormReturn, useWatch } from 'react-hook-form';

interface UseTicketDropzoneProps<T extends { attachments?: File[] }> {
  form: UseFormReturn<T>;
  attachmentsField: Path<T>;
}

export const useTicketDropzone = <T extends { attachments?: File[] }>({
  form,
  attachmentsField,
}: UseTicketDropzoneProps<T>) => {
  const attachments = useWatch({ control: form.control, name: attachmentsField }) ?? [];

  const onDrop = (acceptedFiles: File[]) => {
    const currentAttachments = Array.isArray(attachments) ? attachments : [];

    form.setValue(attachmentsField, [...currentAttachments, ...acceptedFiles] as PathValue<T, Path<T>>, {
      shouldValidate: true,
    });
  };

  const onDropRejected = () => {
    toast({
      description: 'Bitte nur Bilder auswählen.',
      duration: 5000,
      variant: 'destructive',
    });
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: defaultAllowedFileTypes.join(','),
    onDrop,
    onDropRejected,
    noClick: true,
  });

  return {
    getRootProps,
    getInputProps,
    isDragActive,
  };
};
